<template>
  <BlockingLoader :blocking="upsell.loading" :blocking-label="upsell.loadingMessage ?? undefined" />
  <div :class="mode === 'sheet' ? 'relative w-full max-h-[calc(100dvh-5rem)] flex flex-col bg-white overflow-hidden rounded-t-3xl sm:max-w-md' : 'protein-pack-pdp modal-content p-0 overflow-hidden max-w-sm flex flex-col h-[calc(100vh-2rem)]'">
    <!-- Close button -->
    <CloseButton
      class="absolute top-3 right-3 z-10"
      @click="handleClose"
    />

    <!-- scrollable content -->
    <div class="overflow-y-auto flex-1 w-full">
      <div class="w-full px-4 pt-6">
        <div class="aspect-image w-full rounded-2xl overflow-hidden mb-4">
          <video
            class="w-full h-full object-cover"
            :src="videoSrc"
            muted
            autoplay
            loop
            playsinline
            preload="metadata"
          />
        </div>
      </div>

      <div class="flex flex-col items-center gap-3 text-center px-6 mt-4">
        <h1 class="text-2xl font-bold">
          The Protein Pack
        </h1>
        <p class="text-sm text-neutral-700 leading-relaxed">
          Add an extra 10g with The Protein Pack. Crafted specifically to mix with all flavors. Only $1.25 per pack.
        </p>
      </div>

      <!-- What's Inside -->
      <div class="relative flex flex-col items-center gap-4 pb-6 pt-12 mt-6 w-full border-t bg-green-300">
        <div class="border px-6 py-2 rounded-full text-lg font-semibold bg-white absolute -top-5">
          What's Inside?
        </div>
        <div class="flex flex-wrap gap-2 justify-center px-6">
          <div
            v-for="ingredient in upsell.ingredients"
            :key="ingredient"
            class="px-2 py-1 bg-white rounded-full text-xs font-semibold text-gray-800"
          >
            {{ ingredient }}
          </div>
        </div>
<div class="p-3 rounded-2xl bg-white mx-4">
          <ResponsiveImage
            v-if="upsell.nutritionImage"
            class="w-64"
            :image="upsell.nutritionImage"
            :alt="upsell.product?.title ?? 'Nutrition Facts'"
            :width="256"
            loading="lazy"
          />
          <p class="mt-2 text-gray-800 text-xs text-left font-semibold uppercase leading-4">
            Does not contain erythritol.
          </p>
        </div>
      </div>
    </div>

    <!-- Sticky footer CTA -->
    <div class="bg-white px-4 py-4">
      <DisclosureButton
        class="+large +green w-full"
        :value="upsell.upsellPriceCents"
        @click="handleAdd"
      >
        Add {{ upsell.displayPackCount }} Packs
      </DisclosureButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CloseButton, BlockingLoader } from '@oatsovernight/storybook'
import { useProteinPackUpsellStore } from '@/stores'
import { useThemeStore } from '@/stores'
import ResponsiveImage from '@/components/shared/v2/responsive-image.vue'
import DisclosureButton from './disclosure-button.vue'
import BundleSummaryHalfSheet from './bundle-summary-half-sheet.vue'

const props = withDefaults(defineProps<{ mode?: 'sheet' | 'modal' }>(), { mode: 'sheet' })

const upsell = useProteinPackUpsellStore()
const { sheet, modal } = useThemeStore()

const videoSrc = window.innerWidth < 640
  ? 'https://cdn.shopify.com/videos/c/o/v/dc838fd96be44ead9851e35ba71bda55.mp4'
  : 'https://cdn.shopify.com/videos/c/o/v/02591d2d2f1f41d9a652620b5f93cac0.mp4'

const handleClose = () => {
  modal.close()
  if (props.mode === 'sheet') {
    sheet.open(BundleSummaryHalfSheet)
  }
}

const handleAdd = async () => {
  await upsell.add()
  handleClose()
}
</script>

<style>
.modal:has(.protein-pack-pdp) {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
